export const callAuditStrings = {
  title: "Auditoría de llamadas",
  subtitle:
    "El director comercial o coach debe auditar al menos el mínimo mensual de llamadas contestadas por asesor.",
  queuePageSubtitle:
    "Consulta el progreso de coordinadores y directores comerciales, y el detalle de cada auditoría.",
  auditorProgressTitle: "Progreso por auditor",
  auditorProgressSubtitle:
    "Solo coordinadores (Sub) y directores comerciales (Líder principal). Mínimo mensual de llamadas auditadas.",
  roleColumn: "Rol",
  noAuditorsForProgress: "No hay usuarios coordinador o director comercial activos.",
  auditResultsTitle: "Detalle de auditorías",
  auditResultsSubtitle: "Listado de llamadas auditadas en el mes (filtro por asesor opcional).",
  monthLabel: "Mes",
  agentLabel: "Asesor (opcional)",
  callerFilterLabel: "Asesor de la llamada (opcional)",
  search: "Actualizar",
  agentColumn: "Asesor",
  progressColumn: "Progreso",
  pendingColumn: "Pendientes",
  auditedColumn: "Auditadas",
  noCompletedAudits: "Sin auditorías completadas este mes.",
  checklistSummary: "indicadores",
  failedIndicatorsTooltip: "Indicadores no cumplidos",
  noReviewerNotes: "Sin notas del auditor",
  auditedByOther: "Esta llamada fue auditada por",
  yourAudit: "Tu auditoría",
  viewAudit: "Ver auditoría",
  auditorLabel: "Auditor",
  auditorColumn: "Auditor",
  callerColumn: "Asesor (llamada)",
  dateColumn: "Fecha",
  indicatorsColumn: "Indicadores",
  resumeColumn: "Resumen",
  indicatorsResumeAria: "Resumen de indicadores de la rúbrica",
  indicatorPassed: "Cumple",
  indicatorFailed: "No cumple",
  noAuditResults: "No hay auditorías completadas para el mes seleccionado.",
  actionsColumn: "Acciones",
  auditCall: "Auditar",
  reanalyzeAi: "Reanalizar IA",
  saveAudit: "Guardar auditoría",
  humanSection: "Tu evaluación",
  aiSection: "Evaluación IA",
  transcriptSection: "Transcripción",
  diarizedSection: "Diálogo inferido (IA)",
  interestScore: "Nivel de interés",
  totalScore: "Puntaje",
  totalScoreOf: "pts",
  pointsLabel: "pts",
  notes: "Notas del auditor",
  aiPending: "Análisis IA en curso…",
  aiFailed: "El análisis IA falló",
  noAiYet: "Sin análisis IA aún",
  close: "Cerrar",
  allAgents: "Todos los asesores",
  aiReviewTitle: "Revisión auditoría IA",
  aiReviewSubtitle: "Vista exclusiva para administrador CRM: consulta evaluaciones generadas por DeepSeek.",
  aiStatusColumn: "Estado IA",
  callColumn: "Llamada",
  viewAi: "Ver IA",
  runAiAnalysis: "Analizar con IA",
  onlyWithoutAi: "Solo sin análisis IA",
  excludeWithoutTranscript: "Ocultar sin transcripción",
  noTranscriptChip: "Sin transcripción",
  paginationRange: "Mostrando {from}–{to} de {total}",
  paginationRowsPerPage: "Filas",
  aiStatusNone: "Sin análisis",
  aiStatusPending: "En proceso",
  aiStatusCompleted: "Completado",
  aiStatusFailed: "Fallido",
  adminOnly: "Esta sección es solo para administrador CRM.",
  interestColumn: "Interés",
  scoreColumn: "Puntaje",
  rubricColumn: "Rúbrica",
  kpiTotalCalls: "Llamadas del mes",
  kpiAiCompletedPct: "IA completada",
  kpiAvgInterest: "Interés promedio",
  kpiAvgTotalScore: "Puntaje promedio",
  kpiTopFailedRubric: "Rúbrica más fallida",
  kpiDateBasisCall: "Métricas según fecha de la llamada (contestada)",
  kpiMonthScopeNote:
    "El rango abarca varios meses; estas métricas corresponden al mes de la fecha «Hasta».",
  kpiSectionTitle: "Auditoría de llamadas (IA)",
  ceoKpiCallsAiSection: "KPI Llamadas AI",
  accordionRubricDetail: "Detalle de rúbrica",
  accordionTranscript: "Transcripción",
  accordionDiarized: "Diálogo inferido (IA)",
  utterancesSection: "Turnos de conversación",
  noAiSummary: "—",
}
